import { Inject, Injectable, EventEmitter } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Observable, Subject } from 'rxjs';
import { FGAData } from '../fga/models';
@Injectable({
	providedIn: 'root'
})
export class TaskManagerStateService {

	state: TpromsState;


	private readonly currentState;
	stateValue;
	private guidStateSource = new BehaviorSubject<string>(''); // NOSONAR
	guidState = this.guidStateSource.asObservable();
	private nameStateSource = new BehaviorSubject<string>(''); // NOSONAR
	nameState = this.nameStateSource.asObservable();
	private IDStateSource = new BehaviorSubject<string>(''); // NOSONAR
	IDState = this.IDStateSource.asObservable();
	private roleStateSource = new BehaviorSubject<string>(''); // NOSONAR
	roleState = this.roleStateSource.asObservable();
	public details$ = new BehaviorSubject<FGAData>(null);
	constructor() {

		this.state = {
			namc: '',
			WorkdayID: '',
			Name: '',
			Role: ''
		};
		this.currentState = new BehaviorSubject<TpromsState>(this.state);
		this.stateValue = this.currentState.asObservable();
	}

	setGUIDState(name: string) {
		this.guidStateSource.next(name);
	}
	setNameState(name: string) {
		this.nameStateSource.next(name);
	}
	setIDState(ID: string) {
		this.IDStateSource.next(ID);
	}
	setroleState(role: string) {
		this.roleStateSource.next(role);
	}

	getNamc(): Observable<any> {
		return this.stateValue;
	}

	setNamc(namc: any) {
		this.currentState.next(namc);
	}
	getDetails(): Observable<FGAData> {
		return this.details$.asObservable();
	}



}


export interface TpromsState {

	namc: string;
	WorkdayID: string;
	Name: string;
	Role: string;
}



